import axios from 'axios';

const AxiosClient = () => {
    const token = JSON.parse(localStorage.getItem("session")).token
    let defaultOptions = {
        baseURL: process.env.REACT_APP_ENDPOINT,
        validateStatus: function (status) {
            return status >= 200 && status < 500;
        }
    }
    if(token){
        defaultOptions.headers = {
            'Authorization': `Bearer ${token}`
        }
    }
    return  axios.create(defaultOptions);
}

export default AxiosClient;